/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/24
 * @updateTime 2021/8/24
 * @decription 申请保全 =》基本信息模块
 */
// 标题组件
import Slogan from '@/components/common/slogan'
// 模块预览组件
import ccPreviewModule from '@/components/common/preview-module/index.vue';
import {dbqkType, typeBqlb, typeBqlx, typeFsccFsqj, typeTjrlx, typeAjlx} from "@/filters";
export default {
    name: 'BasicInfo',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        Slogan,
        ccPreviewModule
    },
    // 参数
    props: {},
    // 数据
    data() {
        return {
            // 基本信息数据
            basicData: {},
            // 转化之后的数据
            transformData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 获取基本数据
        this.getData();
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 请求数据
         * @param {Object} params 请求参数
         * */
        requestData(params) {
            return this.$axios.get('ssbq/api/bqsqinfo', params);
        },

        /**
         * 获取行数据
         * @param {String} name 名称
         * @param {String|Number} value 值
         * @returns {Object}
         * */
        getRowData(name, value) {
            return {
                name: name,
                value: value
            };
        },

        /**
         * 获取转化之后的数据
         * @returns {Array} 转化之后的信息项数组
         * */
        getTransformData(data) {
            const _transformItemData = [];
            // 申请法院
            _transformItemData.push(this.getRowData('申请法院', data.cSqdyfymc));
            _transformItemData.push(this.getRowData('保全类型', data.cBqlxName));
            _transformItemData.push(this.getRowData('保全类别', data.cBqlbName));
            // 诉前保全、执行前保全
            if (/1|4/.test(data.cBqlb)) {
                _transformItemData.push(this.getRowData('非诉期间', data.cFsqjName));
            } else if (data.cBqlb == 2) {
                // 保全类别为2 诉讼保全
                _transformItemData.push(this.getRowData('案件类型', data.cAjlxName));
                // 民事、刑事案件
                if (/1|2/.test(data.nAjlx)) {
                    _transformItemData.push(this.getRowData('案由', data.cAy));
                } else if (data.nAjlx == 6) {
                    // 2021年之后的案由
                    if (data.cAhNf >= 2021) {
                        _transformItemData.push(this.getRowData('行政主体类型', data.cAyName));
                        _transformItemData.push(this.getRowData('行政案由名称', data.cXzaymc));
                    } else {
                        // 2021年之前的案由
                        _transformItemData.push(this.getRowData('案由(主体类型)', data.cAyName));
                        _transformItemData.push(this.getRowData('案由(行为种类)', data.cAyxzxwName));
                    }
                }
                _transformItemData.push(this.getRowData('案号', data.cBqah));
            }
            _transformItemData.push(this.getRowData('申请保全金额(元)', data.nSqbqje));
            _transformItemData.push(this.getRowData('建议保全费(元)', data.nSqbqdcsfy));
            _transformItemData.push(this.getRowData('担保情况', data.cDbqkName));
            _transformItemData.push(this.getRowData('提交人', data.cTjr));
            _transformItemData.push(this.getRowData('提交日期', data.dtTjsj));
            _transformItemData.push(this.getRowData('提交人身份', data.cTjrlxName));
            return _transformItemData;
        },

        /**
         * 获取数据
         * */
        getData() {
            // 请求保全基本信息数据
            this.requestData({
                // 保全id
                bqid: sessionStorage.getItem('bqid')
            }).then(res => {
                const _data = res.data;
                const _transformData = [];
                // 保全类别名称
                _data.cBqlbName = typeBqlb(res.data.cBqlb);
                // 保全类型名称
                _data.cBqlxName = typeBqlx(res.data.cBqlx);
                // 非诉期间名称
                _data.cFsqjName = typeFsccFsqj(_data.cFsqj);
                // 担保情况名称
                _data.cDbqkName = dbqkType(_data.cDbqk);
                // 提交人身份
                _data.cTjrlxName = typeTjrlx(_data.cTjrlx);
                // 案件类型为6==》行政案件，需要处理案由
                if (_data.nAjlx === 6) {
                    // 案由
                    const _cAy = _data.cAy.split(';');
                    // 获取第一个信息项
                    _data.cAyName = _cAy.splice(0, 1);
                    // 除去第一个的信息
                    _data.cAyxzxwName = _cAy.join(';');
                }
                _data.cAjlxName = typeAjlx(_data.nAjlx)
                // 转化之后的数据
                _transformData.push(this.getTransformData(_data));
                // 基础数据
                this.basicData = _data;
                // 转化之后的数据
                this.transformData = _transformData;
                // 加载完成
                this.$emit('loaded', this.basicData);
            });
        }
    }
};
